function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.372 45.994a4.603 4.603 0 01-7.44-5.331M34.938 40.808a4.603 4.603 0 11-8.09-.165"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.338 47.566c.42.694.66 1.392.66 2.261a4.603 4.603 0 11-8.604-2.277M31.999 36.018a4.603 4.603 0 01-4.603 4.603 4.603 4.603 0 01-4.603-4.603 4.603 4.603 0 014.603-4.603 4.603 4.603 0 014.603 4.603z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.965 39.038a4.603 4.603 0 11-3.474-7.623c1.433 0 2.493.584 3.337 1.611M30.974 32.836a4.603 4.603 0 110 6.364M19.983 31.46a4.603 4.603 0 017.196-5.621"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.922 31.415c-.43-.7-.677-1.42-.677-2.301a4.603 4.603 0 118.683 2.134M34.472 25.884a4.603 4.603 0 113.825 7.8M16.351 33.665a4.604 4.604 0 114.024-7.723M23.285 24.283a4.603 4.603 0 118.127.176M16.466 24.445a4.603 4.603 0 017.262-5.508M31 19a4.603 4.603 0 017.3 5.488"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.545 6.811c3.01-2.11 5.291-1.681 7.294-.677-.448-1.314-.959-3.09.125-3.856.893 3.075 6.77 4.548 6.67 8.016-.098 3.467-7.617 1.8-10.94 3.502-.062-2.055 2.857-2.637 3.793-3.103-4.44-.707-5.14-3.279-6.942-3.882zM10.946 6.945c3.297-.45 9.718 1.24 13.553 3.756M40.32 11.038c-.38-.073-.287.476-.122.632.445.421 1.135.071 1.385-.388.448-.821-.096-1.8-.897-2.139-1.174-.497-2.477.264-2.892 1.407-.554 1.522.43 3.158 1.915 3.646 1.87.615 3.842-.597 4.4-2.425.677-2.214-.763-4.526-2.934-5.154-2.56-.74-5.21.929-5.908 3.444-.805 2.904 1.095 5.896 3.954 6.662 3.248.87 6.582-1.261 7.415-4.464.935-3.593-1.426-7.267-4.973-8.168-3.937-1-9.664 2.007-14.267 6.117M30.848 3.796c-2.742 2.812-5.02 9.174-3.452 13.81M24.499 10.701l2.448 3.452"
}));

var SvgGrapes = function SvgGrapes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrapes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Grapes.c7eb9db1.svg";
export { ForwardRef as ReactComponent };